"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const _ActionTypes = require("./actionTypes");
const statusLens = monocle.Lens.fromProp('status');
const inviteRowsLens = monocle.Lens.fromProp('inviteRows');
const errorsLens = monocle.Lens.fromProp('errors');
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const initialState = {
        isOpen: false,
        status: 'STANDBY',
        inviteRows: [],
        errors: fp.option.none
    };
    const methods = {};
    // Fetch
    methods[ActionTypes.TOGGLE_MODAL] = (state) => (Object.assign(Object.assign({}, initialState), { isOpen: !state.isOpen }));
    methods[ActionTypes.SELECT_ITEM] = (state, action) => inviteRowsLens.modify((rows) => rows.map((row) => {
        return row.uuid === action.payload.uuid
            ? Object.assign(Object.assign({}, row), { group: action.payload.itemId }) : row;
    }))(state);
    methods[ActionTypes.UPDATE_EMAILS] = (state, action) => inviteRowsLens.modify((rows) => rows.map((row) => {
        return row.uuid === action.payload.uuid
            ? Object.assign(Object.assign({}, row), { emails: action.payload.emails }) : row;
    }))(state);
    methods[ActionTypes.UPDATE_LANGUAGE] = (state, action) => inviteRowsLens.modify((rows) => rows.map((row) => {
        return row.uuid === action.payload.uuid
            ? Object.assign(Object.assign({}, row), { language: action.payload.language }) : row;
    }))(state);
    methods[ActionTypes.ADD_ROW] = (state, action) => inviteRowsLens.modify((rows) => [...rows, action.payload])(state);
    methods[ActionTypes.REMOVE_ROW] = (state, action) => {
        const rows = inviteRowsLens.get(state);
        const rowIdx = rows.findIndex((x) => x.uuid === action.payload.uuid);
        if (rowIdx === -1) {
            return state;
        }
        rows.splice(rowIdx, 1);
        return inviteRowsLens.set([...rows])(state);
    };
    methods[ActionTypes.INVITE_REQUEST] = (state) => fp.function.compose(errorsLens.set(fp.option.none), statusLens.set('INVITING'))(state);
    methods[ActionTypes.INVITE_SUCCESS] = (state) => statusLens.set('INVITED')(state);
    methods[ActionTypes.INVITE_FAILED] = (state) => statusLens.set('FAILED')(state);
    methods[ActionTypes.INVITE_VALIDATION] = (state, action) => fp.function.compose(errorsLens.set(fp.option.some(action.payload)), statusLens.set('STANDBY'))(state);
    methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, initialState));
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods, ActionTypes };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map